module.exports = __webpack_public_path__ + "img/messagerie.d1fb6890.png";